import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export interface ComparisionDialogProps {
	isOpen: boolean;
	onToggleModal: (isopen: boolean) => void;
	showComparison: boolean;
}

function ComparisionDialog({ isOpen, onToggleModal, showComparison }: ComparisionDialogProps) {
	function redirectToComparePage() {
		window.location.href = '/Product/ViewComparison';
	}
	return (
		<>
			<Modal zIndex={99999} isOpen={isOpen} toggle={() => onToggleModal(false)} className="modal-md">
				<ModalHeader tag="h4" toggle={() => onToggleModal(false)}>
					Product Compare
				</ModalHeader>
				<ModalBody>
					<p>The selected product has been added to your comparison list.</p>
				</ModalBody>
				<ModalFooter>
					<div className="d-flex flex-wrap quotebutton">
						<button
							data-test-selector="btnOK"
							type="button"
							id="btn-cancel-popup"
							className="btn btn-primary"
							data-dismiss="modal"
							onClick={() => onToggleModal(false)}
						>
							Add More
						</button>
						{showComparison && (
							<button
								data-test-selector="btnViewCompare"
								type="button"
								id="btn-cancel-popup"
								className="btn btn-secondary mt-3 mt-md-0 ml-0 ml-md-3"
								data-dismiss="modal"
								onClick={() => redirectToComparePage()}
							>
								View Comparison
							</button>
						)}
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
}

export default ComparisionDialog;
